import { useStoreActions } from '../store';

interface MuxProviderProps {
  children: any;
}

export function MuxProvider(props: MuxProviderProps) {
  const muxActions = useStoreActions(actions => actions.mux);

  muxActions.enable();

  return props.children;
}
